import { render, staticRenderFns } from "./vForm.vue?vue&type=template&id=1c03cce6&"
import script from "./vForm.vue?vue&type=script&lang=ts&"
export * from "./vForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports